import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {truncate} from '../../../shared/utils/lodash-functions';
import {stripURL} from '../../utils/strip-text';
import Text from '../typography/text';
import TwitterIcon from './twitter-icon.svg';
import WebsiteIcon from './website-icon.svg';
import LocationIcon from './location-icon.svg';
import CompanyIcon from '../../library/icons/company.svg';
import ToolProfileIcon from './tool-profile-icon.svg';
import {useSendAnalyticsEvent} from '../../enhancers/analytics-enhancer';

const Container = glamorous.div(
  {
    display: 'flex',
    justifyContent: 'center',
    '> *': {
      height: 'auto',
      marginTop: 11,
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      flexWrap: 'nowrap',
      '&:first-child': {
        marginLeft: 0
      }
    }
  },
  ({layout}) => ({
    flexDirection: layout,
    flexWrap: layout === 'row' ? 'wrap' : 'nowrap',
    '> *': {
      marginLeft: layout === 'row' ? 10 : 0
    }
  })
);

const Location = glamorous(Text)({
  textTransform: 'capitalize'
});

const Icon = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 14,
  width: 14,
  marginRight: 6
});

const Links = ({
  twitter,
  website,
  location,
  company,
  isCompany,
  toolProfile,
  truncateLength = 23,
  onClick,
  layout = 'row'
}) => {
  const sendAnalyticsEvent = useSendAnalyticsEvent();
  const twitterUrl = `http://twitter.com/${twitter}`;
  return (
    <Container layout={layout}>
      {toolProfile && (
        <a
          onClick={() => {
            sendAnalyticsEvent('click_toolProfileLink');
            onClick('tool', toolProfile);
          }}
          href={toolProfile}
        >
          <Icon>
            <ToolProfileIcon />
          </Icon>{' '}
          <Text>Tool profile</Text>
        </a>
      )}
      {isCompany && company && (
        <a
          onClick={() => {
            sendAnalyticsEvent('click_companyProfileLink');
            onClick('company', company);
          }}
          href={company}
          title={company}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon>
            <CompanyIcon />
          </Icon>{' '}
          <Text>Company profile</Text>
        </a>
      )}
      {twitter && (
        <a
          onClick={() => {
            sendAnalyticsEvent('click_twitterLink');
            onClick('twitter', twitterUrl);
          }}
          href={twitterUrl}
        >
          <Icon>
            <TwitterIcon />
          </Icon>{' '}
          <Text>{truncate(twitter, truncateLength)}</Text>
        </a>
      )}
      {website && (
        <a
          onClick={() => {
            sendAnalyticsEvent('click_websiteLink');
            onClick('website', website);
          }}
          href={website}
        >
          <Icon>
            <WebsiteIcon />
          </Icon>{' '}
          <Text>{truncate(stripURL(website), {length: truncateLength})}</Text>
        </a>
      )}
      {location && (
        <span>
          <Icon>
            <LocationIcon />
          </Icon>{' '}
          <Location>{truncate(location, {length: truncateLength})}</Location>
        </span>
      )}
    </Container>
  );
};

Links.propTypes = {
  twitter: PropTypes.string,
  website: PropTypes.string,
  location: PropTypes.string,
  truncateLength: PropTypes.number,
  onClick: PropTypes.func,
  isCompany: PropTypes.bool,
  company: PropTypes.string,
  toolProfile: PropTypes.string,
  layout: PropTypes.oneOf(['row', 'column'])
};

export default Links;
